import React from "react";
import ReactDOM from "react-dom";
import RootContainer from "./ui/containers/Root";

export default function load(root, session) {
  if (root === null) {
    return null;
  }

  const emarsysMappingCustomerId = root.dataset.emarsysMappingCustomerId;
  const isProductPage = JSON.parse(root.dataset.isProductPage);
  const programmeId = root.dataset.programmeId || null;

  ReactDOM.render(
    <RootContainer
      session={session}
      emarsysMappingCustomerId={emarsysMappingCustomerId}
      isProductPage={isProductPage}
      programmeId={programmeId}
    />,
    root
  );
}
